import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, ROLE_RANK } from "../lib/auth";

export default function ProtectedRoute({ children, minRole = "telecaller" }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/admin/login" replace />;
  if (ROLE_RANK[user.role] < ROLE_RANK[minRole]) {
    return (
      <div className="p-10">
        <h2 className="font-display text-2xl font-bold text-[#06152D]">Access denied</h2>
        <p className="mt-2 text-[#52525B]">Your role does not have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
